<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage['SMB']['GPSUB']}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4">
                                <span class='searchLabel'>{{this.getLanguage['GL']['AGT']}} :</span>
                                <customtreeselect :multiple="false"
                                            :flat="true"
                                            :load-options="loadAgentOptions"
                                            :options="ddAgentList"
                                            :auto-load-root-options="convertToBool(searchAgent)"
                                            :defaultExpandLevel="Infinity"
                                            @input="selectAgentOptions"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            v-model="searchAgent" />
                                <span class="ErrMsg"></span>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SAGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :options="ddSubAgentList"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="searchSubAgent"
                                            openDirection="below"
                                            @input="selectSubAgentOptions" />
                                <span class="ErrMsg">{{ ValidationErrMsg('SAGT') }}</span>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click="newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage['SMB']['GPSUB']}}</strong>
                    <div class="d-flex">
                        <CButton v-if="arr_GameProviderList && arr_GameProviderList.length != 0 && this.searchSubAgent!= null && checkModuleAccess2(constAccessType.edit)" class='searchBtn' size="sm" color="info" @click="SaveConfig()"><span>{{this.getLanguage["BTN"]["SV"]}}</span></CButton>
                        <div class="pageBtn">
                            <button @click="ctrPage(+int_Page - 1)">
                                <span class="arrowLeft"></span>
                            </button>
                            <input class="page-control"
                                   v-model="int_Page"
                                   type="number"
                                   v-shortkey.avoid
                                   @keyup="ctrPage(+int_Page,0)" />
                            <span class="tableItemCount">/ {{int_TP}}</span>
                            <button @click="ctrPage(+int_Page + 1)">
                                <span class="arrowRight"></span>
                            </button>
                        </div>
                    </div>
                </header>
                <span style="justify-content: right" v-if="searchSubAgent!= null && hasEnableGPI == null && checkModuleAccess2(constAccessType.edit)" class="ErrMsg">{{ ValidationErrMsg('EGPI') }}</span>
                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage['GL']['ID']}}</th>
                                <th>{{this.getLanguage['GAME']['PROV']}} <i @click="setSortTable('PN')" :class="setSortLogo('PN')" class="sortlogo"></i></th>
                                <th v-if="checkModuleAccess2(constAccessType.view)">
                                    {{this.getLanguage['GAME']['RS']}}
                                    <span class="float-right" v-if="arr_GameProviderList && arr_GameProviderList.length > 0 &&checkModuleAccess2(constAccessType.edit)">
                                        <label class="switch">
                                            <input type="checkbox" v-model="selectStatus">
                                            <span class="slider round"></span>
                                        </label>
                                    </span>
                                </th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage['GL']['ID']}}</th>
                                <th>{{this.getLanguage['GAME']['PROV']}} <i @click="setSortTable('PN')" :class="setSortLogo('PN')" class="sortlogo"></i></th>
                                <th v-if="checkModuleAccess2(constAccessType.view)">
                                    {{this.getLanguage['GAME']['RS']}}
                                    <span class="float-right" v-if="arr_GameProviderList && arr_GameProviderList.length > 0 && checkModuleAccess2(constAccessType.edit)">
                                        <label class="switch">
                                            <input type="checkbox" v-model="selectStatus">
                                            <span class="slider round"></span>
                                        </label>
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <td colspan="100%" v-if="arr_GameProviderList && arr_GameProviderList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tbody v-for="(data,index) in arr_GameProviderList">
                            <tr>
                                <td>
                                    <span class="grid-line">
                                        {{ CountItem(index+1) }}
                                    </span>
                                </td>
                                <td>{{ renderProviderName(data.PN) }}</td>
                                <td v-if="checkModuleAccess2(constAccessType.view)" class="text-center">
                                    <label class="switch">
                                        <input true-value="2" false-value="1" v-model="data.RS" type="checkbox" :disabled="!checkModuleAccess2(constAccessType.edit)" />
                                        <span class="slider round" :style="disabledPointer()"></span>
                                    </label>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters } from 'vuex';
    import genericHelper from "@/modules/GenericHelper.js";
    import { required } from "vuelidate/lib/validators";
    import { constAccessType, constStatus, loadingFullScreen } from '@/modules/Constant.js';
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading
        },
        data() {
            return {
                bool_CV: false, // Check Validation
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                str_FV: "", //Filter Value
                searchCategory: null,
                searchProvider: null,
                searchAgent: null,
                searchAgi: '',
                ddCategoryList: null,
                ddAgentList: null,
                ddProviderList: null,
                arr_GameProviderList: [],
                constAccessType: constAccessType,
                rtSubBrand: 0,
                ddDefaultSubBrand: null,
                ddSubAgentList: [],
                searchSubAgent: null,
                hasEnableGPI: null
            }
        },
        methods: {
            SaveConfig() {
                this.bool_CV = true;
                var that = this;
                this.$v.searchSubAgent.$touch();
                this.$v.hasEnableGPI.$touch();
                if (!this.$v.searchSubAgent.$error && !this.$v.hasEnableGPI.$error) {
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    this.bool_CV = false;
                    this.postDataApi(`/api/game/ssubgp`, this.arr_GameProviderList,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                            }
                            that.getGameProviderList();
                        });
                }
            },

            checkModuleAccess2(type) {
                return this.checkModuleAccess('GPSUB', 'GS', type);
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getGameProviderList();
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                this.getGameProviderList();
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getGameProviderList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            ValidationErrMsg(langKey = "") {
                if (this.bool_CV) {
                    if (langKey == 'SAGT') {
                        var validateObj = this.$v.searchSubAgent;
                        if (validateObj.required != undefined && !validateObj.required) {
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["GL"][langKey]);
                        }
                    } else if (langKey == 'EGPI') {
                        var validateObj = this.$v.hasEnableGPI;
                        if (validateObj.required != undefined && !validateObj.required) {
                            return this.getLanguage["GL"][langKey];
                        }
                    }
                }
            },
            getGameProviderList() {

                this.bool_CV = true;
                var that = this;
                var hasDefaultPath = false;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (path) {
                    hasDefaultPath = true;
                }

                if (this.searchAgi) {
                    path += "&f.AGI=" + this.searchAgi;
                } else {
                    path += "&f.AGI=0";
                }

                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }

                this.$v.searchSubAgent.$touch();
                if (!this.$v.searchSubAgent.$error) {
                    this.bool_fullLoading = true;
                    this.bool_CV = false;
                    this.getDataApi(`/api/game/lsubgp?${path}`,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.int_TP = Math.max(d.D.TotalPages, 1);
                                that.int_Total = d.D.TotalItems
                                that.arr_GameProviderList = d.D.Items;
                                that.resizeTableHead();
                            }
                        });
                }
            },
            loadAgentOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentList = d.dropdownlist;
                            if (that.ddAgentList.length > 0) {
                                that.ddAgentList.forEach(that.disableAgentGroupParent);
                            }
                        }
                        else {
                            that.ddAgentList = null;
                        }

                        callback();
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            selectAgentOptions(value, instanceId) {
                if (value) {
                    this.searchSubAgent = null;

                } else {
                    this.searchAgent = null;
                    this.searchSubAgent = null;
                }
            },
            selectSubAgentOptions(value, instanceId) {
                this.searchAgi = 0;
                if (value) {
                    this.searchAgi = value;
                } else {
                    this.searchSubAgent = null;
                }
            },
            loadProviderOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/gameProv/`,

                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderProviderName(d.dropdownlist[i].label2);
                            }

                            that.ddProviderList = d.dropdownlist;
                        }
                        else {
                            that.ddProviderList = null;
                        }

                        callback();
                    });
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.searchAgent) {
                    parentAGI = this.searchAgent.split("-")[1];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else {
                    this.ddSubAgentList = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddSubAgentList = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddSubAgentList = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.ddSubAgentList = [];
                            }
                            callback(null, that.ddSubAgentList);
                        });
                }
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.searchSubAgent = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                            that.getGameProviderList();
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                    });
            },
            disabledPointer() {
                return (!this.checkModuleAccess2(constAccessType.edit)) ? "cursor:not-allowed; filter:none" : "";
            },
        },
        validations: {
            searchSubAgent: { required },
            hasEnableGPI: {required}
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
            selectStatus: {
                get: function () {
                    var AllStatusTick = 0;
                    //this.hasEnableGPI = null;
                    if (this.arr_GameProviderList && this.arr_GameProviderList != null) {
                        for (var i = 0; i < this.arr_GameProviderList.length; i++) {
                            if (this.arr_GameProviderList[i].RS == 2) {
                                AllStatusTick++;
                            }
                        }
                        this.hasEnableGPI = AllStatusTick == 0 ? null : 1;
                        return this.arr_GameProviderList ? AllStatusTick == this.arr_GameProviderList.length : false;
                    }
                },
                set: function (value) {
                    if (value) {
                        for (var i = 0; i < this.arr_GameProviderList.length; i++) {
                            this.arr_GameProviderList[i].RS = 2;
                        }
                    }
                    else {
                        for (var i = 0; i < this.arr_GameProviderList.length; i++) {
                            this.arr_GameProviderList[i].RS = 1;
                        }
                    }
                }
            },
        },
        created() {
            this.$parent.showSubMenu = 'GS';
            this.$parent.showActiveMenu = 'GS.GPSUB';
            if (this.$route.path == '/AGS/GPSUB') {
                this.$parent.showSubMenu = 'AGS';
                this.$parent.showActiveMenu = 'AGS.GPSUB';
            }
            if (this.getUserInfo.AT == 4) {
                this.loadDefaultSubBrand(0);
            }
        },

        watch: {
            int_Page(newValue) {
                if (newValue > 0 && newValue <= this.int_TP) {
                    this.getGameProviderList(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort, this.str_FV);
                }
            },
            getLanguage() {
                this.getGameProviderList();
            },
            searchSubAgent: function (newData, oldData) {
                if (newData != oldData) {
                    this.arr_GameProviderList = [];
                }
            },
        },
    }
</script>

<style>
    .width80 {
        width: 80px;
        max-width: 100px;
        min-width: 80px;
    }
</style>




// WEBPACK FOOTER //
// src/components/SideMenu/GameSettings/GameProviderBySubAgent.vue